import { forwardRef } from "react";
function SvgClever({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9 20.068C9 13.406 13.905 8 20.937 8c4.312 0 6.896 1.46 9.022 3.579l-3.202 3.75c-1.762-1.624-3.567-2.623-5.854-2.623-3.855 0-6.642 3.246-6.642 7.226 0 4.048 2.71 7.362 6.642 7.362 2.617 0 4.219-1.06 6.015-2.716l3.202 3.28C27.765 30.41 25.147 32 20.733 32 13.998 32 9 26.73 9 20.068Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClever);
export default ForwardRef;
